import React, { FC } from 'react'
import { IconType } from '../../common/types'

const NucStar: FC<IconType> = ({ iconColor = 'currentColor', ...svgProps }) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 19 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M12.7695 5.55859L17.7969 6.29688C18.2188 6.36719 18.5703 6.64844 18.7109 7.07031C18.8516 7.45703 18.7461 7.91406 18.4297 8.19531L14.7734 11.8164L15.6523 16.9492C15.7227 17.3711 15.5469 17.793 15.1953 18.0391C14.8438 18.3203 14.3867 18.3203 14 18.1445L9.5 15.7188L4.96484 18.1445C4.61328 18.3203 4.12109 18.3203 3.80469 18.0391C3.45312 17.793 3.27734 17.3711 3.34766 16.9492L4.19141 11.8164L0.535156 8.19531C0.21875 7.91406 0.113281 7.45703 0.253906 7.07031C0.394531 6.64844 0.746094 6.36719 1.16797 6.29688L6.23047 5.55859L8.48047 0.882812C8.65625 0.496094 9.04297 0.25 9.5 0.25C9.92188 0.25 10.3086 0.496094 10.4844 0.882812L12.7695 5.55859Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucStar
